import React from 'react'
import { connect } from 'react-redux'
import FlowView from 'components/core/FlowView'
import { LoadingIndicator } from 'components/basic'
import API from 'API'

class Embed extends FlowView {
  constructor (props) {
    super(props, 'Embedded URL')
    this.state = {
      loaded: false
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!this.props.match || !nextProps.match) return
    if (this.props.match.url !== nextProps.match.url) {
      API.dispatch({ 'SET_NAVIGATION_PROPS': this.props.match })
      this.setState({loaded: false})
    }
  }

  render () {
    return (
      <div className='content-wrapper flexbox-absolute-center'>
        <LoadingIndicator visible={!this.state.loaded} />
        <iframe src={window.atob(this.props.match.params.link)} frameBorder='0' allowTransparency='true' style={{width: '100%', minHeight: '100%'}} onLoad={e => this.setState({loaded: true})} />
      </div>
    )
  }
}
// eslint-disable-next-line
Embed = connect(state => state.siteReducer)(Embed)
export default Embed



// WEBPACK FOOTER //
// ./src/views/core/embed.js